export default __webpack_public_path__ + "static/media/food-and-restaurant.cc77a726.svg";